import { useEffect, useState } from 'react';

const VARIANTS = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];

export const buildGallerySlides = (images, title, intl, getImageAlt) => {
  const source = Array.isArray(images) ? images : [];
  const seen = new Set();

  const slides = source.reduce((result, image) => {
    const variants = image && image.attributes && image.attributes.variants;
    if (!variants) return result;

    const widths = new Set();
    const available = VARIANTS.map(name => variants[name])
      .filter(variant => {
        if (
          !variant ||
          typeof variant.url !== 'string' ||
          !variant.url ||
          !Number.isFinite(variant.width) ||
          !Number.isFinite(variant.height) ||
          variant.width <= 0 ||
          variant.height <= 0 ||
          widths.has(variant.width)
        )
          return false;
        widths.add(variant.width);
        return true;
      })
      .sort((a, b) => a.width - b.width);

    if (!available.length) return result;
    const largest = available[available.length - 1];
    const id = (image.id && image.id.uuid) || largest.url;
    if (seen.has(id)) return result;
    seen.add(id);

    result.push({
      id,
      sourceImage: image,
      src: largest.url,
      width: largest.width,
      height: largest.height,
      thumbnail: available[0].url,
      srcSet: available.map(variant => ({
        src: variant.url,
        width: variant.width,
        height: variant.height,
      })),
    });
    return result;
  }, []);

  return slides.map((slide, index) => {
    const description =
      typeof getImageAlt === 'function' ? getImageAlt(slide.sourceImage, index) : '';
    return {
      ...slide,
      alt:
        description ||
        [title, intl.formatMessage({ id: 'ProductGallery.photo' }, { index: index + 1, count: slides.length })].filter(Boolean).join(' — '),
    };
  });
}

export const imageSrcSet = (slide) => {
  return slide.srcSet.map(item => item.src + ' ' + item.width + 'w').join(', ');
}

export const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    const update = () => setMatches(media.matches);
    
    update();
    media.addEventListener('change', update);
    
    return () => {
      media.removeEventListener('change', update);
    };
  }, [query]);

  return matches;
};
